import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';
import Loader from '../../../components/Common/Loader/Loader';
import NotFound from '../../../components/NotFound/NotFound';
import messages from '../../../locale/messages';
import getContentPageById from './getContentPageById.graphql';
import { withQuery } from '../../../hoc/withGraphql';
export class EditContentPage extends Component {

    static propTypes = { id: PropTypes.number.isRequired }

    constructor(props) {
        super(props)
        this.component = null;
    }

    componentDidMount() {
        if (typeof window !== 'undefined' && typeof document !== undefined) {
            this.component = require('../../../components/SiteAdmin/ContentPage/AddContentPageForm').default
        }
    }

    render() {
        const { getContentPageById: { getContentPageById, loading }, intl: { formatMessage } } = this.props;
        const isBrowser = typeof window !== 'undefined';
        const isDocument = typeof document !== undefined;
        const AddContentPageForm = this.component;

        let initialValues = {};

        if (!loading && getContentPageById && getContentPageById?.result) {
            initialValues = {
                id: getContentPageById?.result?.id,
                metaTitle: getContentPageById?.result?.metaTitle,
                metaDescription: getContentPageById?.result?.metaDescription,
                pageUrl: getContentPageById?.result?.pageUrl,
                pageTitle: getContentPageById?.result?.pageTitle,
                isEnable: getContentPageById?.result?.isEnable,
                pageBanner: getContentPageById?.result?.pageBanner,
            }

            if (getContentPageById?.result?.dynamicContent?.length > 0) {
                initialValues['content'] = getContentPageById?.result?.dynamicContent?.map((item) => ({
                    content: item?.content || getContentPageById?.result?.content,
                    language: item?.language || 'en-US'
                }))
            } else {
                initialValues['content'] = [{ content: getContentPageById?.result?.content, language: 'en-US' }]
            }
        }

        if (!loading && !getContentPageById?.result?.id) {
            return <NotFound title={formatMessage(messages.pageNotFound)} />;
        } else {
            return (
                <Loader type={"page"} show={loading}>
                    <h1 className='siteAdminPrimaryHeading'> {formatMessage(messages.contentpageManagement)}</h1>
                    {!loading && isBrowser && isDocument && <AddContentPageForm
                        initialValues={initialValues}
                    />}
                </Loader>
            );
        }
    }
}

export default compose(
    injectIntl,
    withQuery(getContentPageById, {
        name: 'getContentPageById',
        options: (props) => ({
            ssr: false,
            variables: {
                id: Number(props.id),
            },
            fetchPolicy: 'network-only'
        })
    })
)(EditContentPage)
